import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type InfoProps = IconProps;
export const Info = ({ className, ...props }: InfoProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={classNames('icon', className)}
    {...props}>
    <circle
      cx="10.0009"
      cy="10.001"
      r="7.16667"
      stroke="currentColor"
      strokeWidth="1.11111"
      strokeLinejoin="round"
    />
    <path
      d="M10.0016 6.05188C9.59488 6.05188 9.26514 6.38163 9.26514 6.78837C9.26514 7.19512 9.59488 7.52486 10.0016 7.52486C10.4084 7.52486 10.7381 7.19512 10.7381 6.78837C10.7381 6.38163 10.4084 6.05188 10.0016 6.05188Z"
      fill="currentColor"
    />
    <path d="M10.0018 8.97063V13.9537" stroke="currentColor" strokeWidth="1.08333" />
  </Icon>
);
